/* PopUpDisplayComponent.js */

"use strict";

const EventEmitter = require("events").EventEmitter;
const Renderer = require("./PopUpDisplayRenderer");
const SteveRouter = require("@gluenetworks/steve_core_router");
const _ = require("lodash");

class PopUpDisplayComponent extends EventEmitter {
    constructor(configOptions) {
        super();

        this._name = _.get(configOptions, "name", undefined);
        this._nameArr = _.get(configOptions, "nameArray", ["", ""]); // <[first, last]> Array of first and last names
        this._email = _.get(configOptions, "email", undefined);
        this._role = _.get(configOptions, "role", undefined);
        this._userId = _.get(configOptions, "userId", undefined);
        this._profileImage = _.get(configOptions, "image", undefined);
        //this._organizations = _.get(configOptions, 'organizations', []);
        //this._activeOrganization = _.get(configOptions, 'activeOrganization', undefined);
        this._projects = _.get(configOptions, "projects", []);
        this._router = new SteveRouter(window, window.history);
        this._shown = _.get(configOptions, "shown", false);
        this._homeBarContext = _.get(configOptions, "context", false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;

        this._name = undefined;
        this._nameArr = undefined;
        this._email = undefined;
        this._role = undefined;
        //this._organizations = undefined;
        //this._activeOrganization = undefined;
        this._shown = undefined;
        this._profileImage = undefined;

        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*_triggerOrganizationChange(newOrganization, oldOrganization, event){
        this.emit('OrganizationChange', newOrganization, oldOrganization, event);
    }*/

    _triggerProjectChange(newOrganization, oldOrganization, event) {
        this.emit("ProjectChange", newOrganization, oldOrganization, event);
    }

    /*_triggerHelpSelected(event){
        this.emit('HelpSelected', event);
    }*/

    _triggerMenuSelected() {
        this.emit("editProfileClicked");
        this._router._window.location.href =
            location.origin + "/frontend/settings/users/edit-my-profile";
    }

    _triggerLogOutSelected(event) {
        this.emit("LogOutSelected", event);
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setName(newVal, arr) {
        this._name = newVal ? newVal : this._name;
        this._nameArr = arr ? arr : this._nameArr;
        this.emit("Name", this._name, this._nameArr);
        return this;
    }

    getName() {
        return this._name;
    }

    getNameArray() {
        return this._nameArr;
    }

    setEmail(newVal) {
        this._email = newVal;
        this.emit("Email", this._email);
        return this;
    }

    getEmail() {
        return this._email;
    }

    setRole(newVal) {
        this._role = newVal;
        this.emit("Role", this._role);
        return this;
    }

    setUserId(newVal) {
        this._userId = newVal;
        this.emit("UserId", this._userId);
        return this;
    }

    getRole() {
        return this._role;
    }

    setProfileImage(newVal) {
        this._profileImage = newVal;
        this.emit("ProfileImage", this._profileImage);
        return this;
    }
    getProfileImage() {
        return this._profileImage;
    }

    /*
    setOrganizations(newVal){
        this._organizations = newVal;
        this.emit('Organizations', this._organizations);
        return this;
    }
    getOrganizations(){
        return this._organizations;
    }

    setActiveOrganization(newVal){
        this._activeOrganization = newVal;
        this.emit('ActiveOrganization', this._activeOrganization);
        return this;
    }
    getActiveOrganization(){
        return this._activeOrganization;
    }*/

    setProjects(newVal) {
        this._projects = newVal;
        this.emit("Projects", this._projects);
        return this;
    }
    getProjects() {
        return this._projects;
    }

    setActiveProject(newVal) {
        this._activeProject = newVal;
        this.emit("ActiveProject", this._activeProject);
        return this;
    }
    getActiveProject() {
        return this._activeProject;
    }

    setShown(newVal) {
        this._shown = newVal;
        this.emit("Shown", this._shown);
        return this;
    }

    getShown() {
        return this._shown;
    }

    /*
    setOrganizationsDisabled(newVal){
        this.emit('OrganizationsDisabled', newVal);
        return this;
    }*/

    setProjectsDisabled(newVal) {
        this.emit("ProjectsDisabled", newVal);
        return this;
    }

    setMenuDisabled(newVal) {
        this.emit("MenuDisabled", newVal);
        return this;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = PopUpDisplayComponent;
